export const ENoteVisibility = {
  "0": "UNKNOWN",
  "1": "STAFF_ONLY",
  "2": "AGENCY_ONLY",
  "99": "EVERYBODY",
  "-1": "ALL"
};

export const EScriptPlaceholder = {
  "0": "UNKNOWN",
  "1": "USER",
  "2": "AGENCY",
  "3": "ENTITY",
  "-1": "ALL"
};

export const EContactType = {
  "0": "UNKNOWN",
  "1": "AGENCY",
  "2": "HOTEL",
  "3": "PROVIDER",
  "-1": "ALL"
};